import { render, staticRenderFns } from "./LeadWebFormSetting.vue?vue&type=template&id=6e21da57"
import script from "./LeadWebFormSetting.vue?vue&type=script&lang=js"
export * from "./LeadWebFormSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports